






















































import FleetManagerTreeDialog from "@/components/fleet/FleetManagerTreeDialog.vue";
import MyDamageDetailSideCard from "@/components/report/user/MyDamageDetailSideCard.vue";
import ErrorCard from "@/components/utility/ErrorCard.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { MrfiktivVehicleViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { VehicleFleetModule } from "@/store/modules/fleet/vehicle-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";
import { debounce } from "debounce";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportWithBanner,
    PaginatedTable,
    MyDamageDetailSideCard,
    FleetManagerTreeDialog,
    ErrorCard,
    MHeader
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetVehicleView extends Vue {
  readonly store = VehicleFleetModule;

  loading = false;
  selectedId: string | null = null;

  updateTableKey = "";

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetAnalyticsView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: this.$t("common.nouns.vehicle"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetVehicleView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get predefinedFilter(): PredefinedFilterType[] {
    return [];
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetIds() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId);
  }

  get fleetId() {
    return FleetManagerModule.selectedFleetId;
  }

  get items() {
    return VehicleFleetModule.filteredAndSorted;
  }

  get totalItems() {
    return VehicleFleetModule.totalItems;
  }

  get i18n() {
    return this.$t("views.fleet.FleetVehicleListView");
  }

  get chips(): IAction[] {
    return [
      {
        text: `${this.totalItems} ${this.$t("common.nouns.vehicles")}`,
        key: "fahrzeuge",
        icon: "mdi-car"
      }
    ];
  }

  get actions(): IAction[] {
    return [
      {
        text: this.$t("views.report.fleet.FleetAnalyticsView.selectionDialog.openFleetTree").toString(),
        key: "fleet",
        exec: () => ((this.$refs.dialog as unknown) as IDialog)?.open(),
        disabled: this.selectedFleetIds.length <= 1
      }
    ].filter(a => !a.disabled);
  }

  get headers() {
    return [
      {
        text: this.$t("objects.vehicle.timestamp.created"),
        align: "left",
        width: 120,
        value: "timestamp.created"
      },
      {
        text: this.$t("objects.vehicle.state"),
        align: "left",
        width: 150,
        value: "state"
      },
      // {
      //   text: this.$t("objects.vehicle.groupId"),
      //   align: "left",
      //   value: "groupId"
      // },
      {
        text: this.$t("objects.vehicle.numberplate"),
        align: "left",
        value: "numberplate"
      },
      {
        text: this.$t("objects.vehicle.identificationnumber"),
        align: "left",
        value: "identificationnumber"
      },
      {
        text: this.$t("objects.vehicle.registration.manufacturerName"),
        align: "left",
        value: "registration.manufacturerName"
      },
      {
        text: this.$t("objects.vehicle.registration.manufacturerDescription"),
        align: "left",
        value: "registration.manufacturerDescription"
      },
      {
        text: this.$t("objects.vehicle.ownership"),
        align: "left",
        value: "ownership"
      },
      { text: "", value: "controls", align: "right", sortable: false }
    ];
  }

  get selectedFleetIds() {
    return FleetManagerModule.selectedFleetIds;
  }

  getState(item: MrfiktivVehicleViewModelGen) {
    if (!item.state) {
      return { color: "grey lighten-4", label: "" };
    }

    return VehicleModule.stateMap.get(item.state);
  }

  async load() {
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      await FleetManagerModule.getFleetTree({ partnerId: this.partnerId, fleetId: this.fleetId });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  async openDetail(item: MrfiktivVehicleViewModelGen) {
    this.$log.debug(item);
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      const vehicle = await VehicleFleetModule.getOne({
        partnerId: this.partnerId,
        fleetId: this.fleetId,
        id: item.id
      });
      this.selectedId = vehicle.id;

      await this.$router.push({ name: "FleetDamageView", query: { vehicleId: vehicle.id } });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  debounceUpdateTable = debounce(this.updateTable, 200);
  updateTable() {
    // We filter using base query. The data access layer has to be cleared of all "old" results.
    this.store.reset();
    this.updateTableKey = FleetManagerModule.selectedFleetIds.join("_");
  }
}
